module.exports = __webpack_public_path__ + "img/gif-bounce-arrow-up.25238502.gif";